import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { ImageLoadCropComponent } from '../image-load-crop/image-load-crop.component';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-image-input',
  standalone: true,
  imports: [
    CommonModule, TranslateModule,
    ButtonModule,  
    ImageLoadCropComponent,
  ],
  templateUrl: './image-input.component.html',
  styleUrls: ['./image-input.component.scss']
})
export class ImageInputComponent implements OnInit {


  @Input() imagePreview: any;
  @Input() maintainAspectRatio: boolean = true;
  @Input() circle: boolean = true;
  @Output() imageChanged = new EventEmitter<string>();

  triggerFileInput$: Subject<void> = new Subject();

  constructor() { }

  ngOnInit(): void {
  }


  onImage(imageBase64: string) {
    this.imageChanged.emit(imageBase64);
    this.imagePreview = imageBase64;
  }

}
